export const root       = '/';
export const ParkingInfo       = '/parking_info';
export const ManualCarAction       = '/manual_car_action';
export const about      = '/אודות';
export const contact    = '/צור_קשר';

/* documentation */
export const docs       = '/docs';

export const login       = '/login';